var viewer_figure_default = {
  "figure": "qRSwX"
};
export {
  viewer_figure_default as default
};
//# sourceMappingURL=viewer-figure-scss.js.map
